import React from 'react'
import * as d3 from './d3.modified.js'
import Uber from './Uber'
// links
import Link from './Link'
import BezierLink from './BezierLink'
// import SVGPatterns from './SVGPatterns'

class Nodebook extends React.Component {
    constructor(props) {
        super(props);
        this._refs = {}

        // render buffers
        this._styleBuffer = []
        this._attrBuffer = []
        this._classBuffer = []

        // container data
        this.containerWidth = undefined
        this.containerHeight = undefined

        // brush
        this.qt = undefined
        this.brush = undefined
        this.brushSelection = []
        this._bCanActivate = true
        this._bShiftPre = false
        this._bShiftPressed = false
        this._bShiftReleased = false
        this._bMouseReleased = true
        this._bSkipOne = false

        // zoom data
        this.currentZoomTransform = d3.zoomIdentity
        this.newZoomTransform = d3.zoomIdentity
        try {
            var tc = JSON.parse(localStorage.getItem(`ndbk${this.props.nodebookid}_transformations`))
        } catch (err) {
            tc = {}
        }
        this.basisTransform = { ...tc };

        this.xVelocity = 0;
        this.yVelocity = 0;
        this.kVelocity = 0;

        this.leftKey = false;
        this.upKey = false;
        this.rightKey = false;
        this.downKey = false;
        this.ctrlKey = false;
    }

    componentDidMount() {
        this.postModifiers()
    }

    enqueueAttrChange = (cmd) => {
        this._attrBuffer.push(cmd)
    }

    enqueueStyleChange = (cmd) => {
        this._styleBuffer.push(cmd)
    }

    enqueueClassChange = (cmd) => {
        this._classBuffer.push(cmd)
    }

    tick = () => {

        // Calculate forces
        let xForce = 0;
        let yForce = 0;
        let kForce = 0;

        let upSwing = 4;
        let halted = false;

        if (this.ctrlKey === false) {
            if (this.upKey) yForce = yForce + upSwing;
            if (this.leftKey) xForce = xForce + upSwing;
            if (this.rightKey) xForce = xForce - upSwing;
            if (this.downKey) yForce = yForce - upSwing;
        } else {
            if (this.upKey) kForce = kForce + upSwing / 100;
            if (this.downKey) kForce = kForce - upSwing / 100;
        }

        this.xVelocity = this.xVelocity * 0.75
        this.yVelocity = this.yVelocity * 0.75
        this.kVelocity = this.kVelocity * 0.75

        if (xForce !== 0) {
            this.xVelocity = this.xVelocity + xForce
        }

        if (yForce !== 0) {
            this.yVelocity = this.yVelocity + yForce
        }

        if (kForce !== 0) {
            this.kVelocity = this.kVelocity + kForce
        }

        if (this.xVelocity !== 0 && Math.abs(this.xVelocity) < 0.01) {
            this.xVelocity = 0
            if (this.xVelocity === 0 && this.yVelocity === 0 && this.kVelocity === 0) {
                halted = true;
            }
        }
        if (this.yVelocity !== 0 && Math.abs(this.yVelocity) < 0.01) {
            this.yVelocity = 0
            if (this.xVelocity === 0 && this.yVelocity === 0 && this.kVelocity === 0) {
                halted = true;
            }
        }
        if (this.kVelocity !== 0 && Math.abs(this.kVelocity) < 0.01) {
            this.kVelocity = 0
            if (this.xVelocity === 0 && this.yVelocity === 0 && this.kVelocity === 0) {
                halted = true;
            }
        }

        if (halted) {
            let transformations_cookie = localStorage.getItem(`ndbk${this.props.nodebookid}_transformations`)
            try { transformations_cookie = JSON.parse(transformations_cookie) } catch (err) { transformations_cookie = {} }
            transformations_cookie = { x: this.currentZoomTransform.x, y: this.currentZoomTransform.y, k: this.currentZoomTransform.k }
            localStorage.setItem(`ndbk${this.props.nodebookid}_transformations`, JSON.stringify(transformations_cookie))
            this.cullNodes()
        }
        // Calculate forces

        // Shift now pressed but wasn't before
        if (this.props.keyPressDict.shift && !this._bShiftPre) {
            this._bShiftPressed = true
        }

        // Shift now released, wasn't before
        if (!this.props.keyPressDict.shift && this._bShiftPre) {
            this._bShiftReleased = true
        }

        this._bShiftPre = this.props.keyPressDict.shift

        if (this._bCanActivate && this._bShiftPressed) {
            this.brush.extent([[0, 0], [this.containerWidth, this.containerHeight]])
            this._refs.brushHolder.select(".selection").attr("display", null);
            this._refs.brushHolder.call(this.brush)
            this._bShiftPressed = false
            this._bMouseReleased = true
        }

        if (this._bShiftReleased && this._bMouseReleased) {
            this._bMouseReleased = false
            this._bShiftReleased = false
            this.brush.extent([[0, 0], [0, 0]]);
            this._refs.brushHolder.call(this.brush);
            this._refs.brushHolder.select(".selection").attr("display", "none");

            this._bCanActivate = true
        }

        if (this.currentZoomTransform.k !== this.newZoomTransform.k ||
            this.currentZoomTransform.x !== this.newZoomTransform.x ||
            this.currentZoomTransform.y !== this.newZoomTransform.y ||
            this.xVelocity !== 0 || this.yVelocity !== 0 || this.kVelocity !== 0) {

            var oldZoomTransform = this.currentZoomTransform

            this.newZoomTransform.x = this.newZoomTransform.x + this.xVelocity;
            this.newZoomTransform.y = this.newZoomTransform.y + this.yVelocity;
            //this.newZoomTransform.k = this.newZoomTransform.k + this.kVelocity; fix zoom center

            this.currentZoomTransform = this.newZoomTransform

            // var transform = d3.zoomIdentity.translate(x, y).scale(k);
            // var transition = (canvas) => {
            //     canvas.transition()
            //         .duration(500)
            //         .call(this.zoom.transform, transform)
            //   }
            // //this._refs.nodesAndLinkHolder.attr('transform', transform)
            // this._refs.svg.call(transition)
            //console.log(this.transition)
            this._refs.nodesAndLinkHolder.attr('transform', this.currentZoomTransform)

            // let transformations_cookie = localStorage.getItem(`ndbk${this.props.nodebookid}_transformations`)
            // try { transformations_cookie = JSON.parse(transformations_cookie) } catch (err) { transformations_cookie= {}}
            // transformations_cookie = {x:this.currentZoomTransform.x, y:this.currentZoomTransform.y, k:this.currentZoomTransform.k}
            // localStorage.setItem(`ndbk${this.props.nodebookid}_transformations`, JSON.stringify(transformations_cookie))
        }

        // execute pending class changes
        for (let i = 0; i < this._classBuffer.length; i++) {
            try {
                this._classBuffer[i].elem.classed(
                    this._classBuffer[i].class,
                    this._classBuffer[i].val
                );
            } catch (err) {
                // WIP
            }
        }
        // execute pending style changes
        for (let i = 0; i < this._styleBuffer.length; i++) {
            try {
                this._styleBuffer[i].elem.style(
                    this._styleBuffer[i].prop,
                    this._styleBuffer[i].val
                );
            } catch (err) {
                // WIP
            }
        }
        // execute pending transformation changes
        for (let i = 0; i < this._attrBuffer.length; i++) {
            try {
                this._attrBuffer[i].elem.attr(
                    this._attrBuffer[i].attr,
                    this._attrBuffer[i].val
                );
            } catch (err) {
                // WIP
            }
        }
        this._attrBuffer = []
        this._styleBuffer = []
        this._classBuffer = []


        requestAnimationFrame(this.tick);
    }

    cullNodes = () => {
        var k = this.currentZoomTransform.k
        var dx = this.currentZoomTransform.x
        var dy = this.currentZoomTransform.y

        var region = {}

        region.x1 = (-100 - dx) / k
        region.x2 = (100 + this.containerWidth - dx) / k

        region.y1 = (-100 - dy) / k
        region.y2 = (100 + this.containerHeight - dy) / k

        // var x0 = region.x1
        // var y0 = region.y1
        // var x3 = region.x2
        // var y3 = region.y2

        // this.qt.visit((tile, x1, y1, x2, y2) => {
        //     if (!tile.length) {
        //         do {
        //             var nodeItem = tile.data
        //             nodeItem._cullPassed = (
        //                 nodeItem.x > region.x1 &&
        //                 nodeItem.x < region.x2 &&
        //                 nodeItem.y > region.y1 &&
        //                 nodeItem.y < region.y2
        //             )
        //         } while (tile = tile.next)
        //     }
        //     return (x1 >= x3 || y1 >= y3 || x2 < x0 || y2 < y0)
        // })

        // // culling
        // this.props.nodesData.forEach(
        //     node => {
        //         node._cullPassed = (
        //             node.x > region.x1 &&
        //             node.x < region.x2 &&
        //             node.y > region.y1 &&
        //             node.y < region.y2
        //         )
        //         //console.log(node.properties.title + (node._cullPassed?"SHOW":"CULL"))
        //     }
        // )

        // this.props.linksData.forEach(
        //     link => {
        //         link._cullPassed = ((
        //                 link.x1 > region.x1 &&
        //                 link.x1 < region.x2 &&
        //                 link.y1 > region.y1 &&
        //                 link.y1 < region.y2
        //             ) || (
        //                 link.x2 > region.x1 &&
        //                 link.x2 < region.x2 &&
        //                 link.y2 > region.y1 &&
        //                 link.y2 < region.y2
        //             )
        //         )
        //         //console.log(node.properties.title + (node._cullPassed?"SHOW":"CULL"))
        //     }
        // )
        // this.props._triggerSetNodes()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.nodebookid !== this.props.nodebookid) {
            this.props = nextProps
            this.postModifiers()
        }
    }

    postModifiers = () => {
        try {
            var tc = JSON.parse(localStorage.getItem(`ndbk${this.props.nodebookid}_transformations`))
        } catch (err) {
            tc = {}
        }
        this.basisTransform = { ...tc };
        this.resizeHandler(true)
        d3.select(window).on('resize', this.resizeHandler)

        if (this.basisTransform.x && this.basisTransform.y && this.basisTransform.k) {
            var transform = d3.zoomIdentity.translate(this.basisTransform.x, this.basisTransform.y).scale(this.basisTransform.k);
        } else {
            transform = d3.zoomIdentity
        }

        let firstPass = true;

        this.qt = d3.quadtree()
            .x(d => d.x)
            .y(d => d.y)
            .addAll(this.props.nodesData)

        // var transform = d3.zoomIdentity.translate(x, y).scale(k);
        // var transition = (canvas) => {
        //     canvas.transition()
        //         .duration(500)
        //         .call(this.zoom.transform, transform)
        //   }
        // //this._refs.nodesAndLinkHolder.attr('transform', transform)
        // this._refs.svg.call(transition)

        let zoom = d3.zoom()
            .scaleExtent([this.props.zoomLevelMin, this.props.zoomLevelMax])
            .on('start', () => {
                this.props.hideCtxMenus()
            })
            .on('zoom', () => {
                //this.props.hideCtxMenus()
                // console.log('ZOOM', d3.event.transform)
                if (d3.event.transform.k > this.currentZoomTransform.k) {
                    this._refs.svg.classed('zoomin', true)
                } else if (d3.event.transform.k < this.currentZoomTransform.k) {
                    this._refs.svg.classed('zoomout', true)
                } else {
                    this._refs.svg.classed('moving', true)
                }
                this.newZoomTransform = d3.event.transform
                //this.props.setZoomLvl(this.newZoomTransform.k)
            })
            .on('end', () => {
                this._refs.svg.classed('zoomin', false)
                this._refs.svg.classed('zoomout', false)
                this._refs.svg.classed('moving', false)
                // Save current transformation at the end of every drag
                // Ignore first pass which gets called when zoom is initialized and is always (0,0,1)
                if (!firstPass) {
                    let transformations_cookie = localStorage.getItem(`ndbk${this.props.nodebookid}_transformations`)
                    try { transformations_cookie = JSON.parse(transformations_cookie) } catch (err) { transformations_cookie = {} }
                    transformations_cookie = { x: this.currentZoomTransform.x, y: this.currentZoomTransform.y, k: this.currentZoomTransform.k }
                    localStorage.setItem(`ndbk${this.props.nodebookid}_transformations`, JSON.stringify(transformations_cookie))
                } else {
                    firstPass = false;
                }

                // this.setState({
                //     zt: this.currentZoomTransform
                // })

                this.cullNodes()

                // KEEP INCASE OF MEMES
                // var k = this.currentZoomTransform.k
                // var dx = this.currentZoomTransform.x
                // var dy = this.currentZoomTransform.y

                // var region = {}

                // region.x1 = (-100-dx) / k
                // region.x2 = (100+this.containerWidth-dx) / k

                // region.y1 = (-100-dy) / k
                // region.y2 = (100+this.containerHeight-dy) / k

                // // var x0 = region.x1
                // // var y0 = region.y1
                // // var x3 = region.x2
                // // var y3 = region.y2

                // // this.qt.visit((tile, x1, y1, x2, y2) => {
                // //     if (!tile.length) {
                // //         do {
                // //             var nodeItem = tile.data
                // //             nodeItem._cullPassed = (
                // //                 nodeItem.x > region.x1 &&
                // //                 nodeItem.x < region.x2 &&
                // //                 nodeItem.y > region.y1 &&
                // //                 nodeItem.y < region.y2
                // //             )
                // //         } while (tile = tile.next)
                // //     }
                // //     return (x1 >= x3 || y1 >= y3 || x2 < x0 || y2 < y0)
                // // })

                // // // culling
                // this.props.nodesData.forEach(
                //     node => {
                //         node._cullPassed = (
                //             node.x > region.x1 &&
                //             node.x < region.x2 &&
                //             node.y > region.y1 &&
                //             node.y < region.y2
                //         )
                //         //console.log(node.properties.title + (node._cullPassed?"SHOW":"CULL"))
                //     }
                // )

                // this.props.linksData.forEach(
                //     link => {
                //         link._cullPassed = ((
                //                 link.x1 > region.x1 &&
                //                 link.x1 < region.x2 &&
                //                 link.y1 > region.y1 &&
                //                 link.y1 < region.y2
                //             ) || (
                //                 link.x2 > region.x1 &&
                //                 link.x2 < region.x2 &&
                //                 link.y2 > region.y1 &&
                //                 link.y2 < region.y2
                //             )
                //         )
                //         //console.log(node.properties.title + (node._cullPassed?"SHOW":"CULL"))
                //     }
                // )
                // this.props._triggerSetNodes()
            })
            .filter(function () {
                if (d3.event.type === "dblclick" && d3.event.target.id !== "S_") return 0
                return (d3.event.button === 0 || d3.event.button === 1);
            })

        this.zoom = zoom
        this._refs.nodesAndLinkHolder.attr('transform', transform)
        this._refs.svg
            .call(zoom)
            .call(zoom.transform, transform)
            .on("click", () => {
                this.props.hideCtxMenus()
                this.props.keyPressDict.link = false
                // deselect everything
                this.props.selectNode()
            })
            .on("contextmenu", () => {
                var domElem = d3.event.srcElement || d3.event.target

                if ((this.props.isCompare || this.props.canEdit === false) && domElem.id[0] !== 'N') {
                    return
                }

                this.props.hideCtxMenus()
                //var domElem = d3.event.srcElement || d3.event.target

                if ('N' == domElem.id[0]) {
                    var nodeId = domElem.id.match(/\d+/)[0]
                    var node = this.props.nodesData[this.props.nodesHashTable[nodeId]]
                    if (node) {
                        node.refs.holder.classed('linkage-can', false)
                        node.refs.holder.classed('linkage-cannot', false)
                    }
                    this.props.showCtxMenu('node', d3.event.x, d3.event.y, { nodeId: nodeId })
                } else if ('S' == domElem.id[0]) {
                    var x = (d3.event.offsetX - this.currentZoomTransform.x) / this.currentZoomTransform.k
                    var y = (d3.event.offsetY - this.currentZoomTransform.y) / this.currentZoomTransform.k
                    this.props.showCtxMenu('svg', d3.event.x, d3.event.y, { position: { x: x, y: y } })
                } else if ('L' == domElem.id[0]) {
                    var linkId = domElem.id.match(/\d+/)[0]
                    this.props.showCtxMenu('link', d3.event.x, d3.event.y, { linkId: linkId })
                }

                // if (domElem.nodeName != "A") {
                //     d3.event.preventDefault()
                //     d3.event.stopPropagation()
                // }
            })

        // this._refs.nodesAndLinkHolder
        //     .call(this.dragBehavior)
        //     .on('click', this.nodeClickHandler)

        this.brush = d3.brush()
        this.brush
            .on("start", () => {
                // console.log('%cbrush start', 'color: green')
                this._bMouseReleased = false
                this.brushSelection = []
            })
            .on("brush", () => {
                // console.log('%cbrush', 'color: blue')
                var extent = d3.event.selection;
                if (!extent)
                    return

                this.searchAndSelect(extent)
            })
            .on("end", () => {
                // console.log('%cbrush end', 'color: red', this.brushSelection)

                this.brushSelection.forEach(node => node._brushed = false)
                this.props.selectMultipleNodes(this.brushSelection, true)
                // this.brushSelection = []

                if (d3.event.sourceEvent && !this._bSkipOne) {
                    this.props.keyPressDict.shift = d3.event.sourceEvent.shiftKey
                }

                if (this._bSkipOne) {
                    this._bSkipOne = false
                } else {
                    this._bSkipOne = true
                }

                this._bMouseReleased = true

                if (d3.event.selection) {
                    this.brush.move(this._refs.brushHolder, [[0, 0], [0, 0]]);
                }
            })

        requestAnimationFrame(this.tick);
    }

    searchAndSelect = (extent) => {
        var zt = this.currentZoomTransform
        var region = {
            x1: (extent[0][0] - zt.x) / zt.k,
            y1: (extent[0][1] - zt.y) / zt.k,
            x2: (extent[1][0] - zt.x) / zt.k,
            y2: (extent[1][1] - zt.y) / zt.k,
        }

        var newBrushSelection = []
        this.brushSelection.forEach(
            node => {
                var covered = (
                    node.x > region.x1 &&
                    node.x < region.x2 &&
                    node.y > region.y1 &&
                    node.y < region.y2
                )
                if (covered) {
                    newBrushSelection.push(node)
                } else {
                    node._brushed = false
                    node._jsx.styleDeselect()
                }
            }
        )
        this.brushSelection = newBrushSelection

        var x0 = region.x1
        var y0 = region.y1
        var x3 = region.x2
        var y3 = region.y2

        // quadtree
        this.qt.visit((tile, x1, y1, x2, y2) => {
            if (!tile.length) {
                do {
                    var nodeItem = tile.data
                    if (nodeItem._selectionId === -1 && !nodeItem._brushed) {
                        var covered = (
                            nodeItem.x > region.x1 &&
                            nodeItem.x < region.x2 &&
                            nodeItem.y > region.y1 &&
                            nodeItem.y < region.y2
                        )
                        if (covered) {
                            this.brushSelection.push(nodeItem)
                            nodeItem._jsx.styleSelect()
                            nodeItem._brushed = true
                        }
                    }
                } while (tile = tile.next)
            }
            return (x1 >= x3 || y1 >= y3 || x2 < x0 || y2 < y0)
        })
    }

    dataChangeHandler = (info) => {
        var created = info.created || []
        var deleted = info.deleted || []

        deleted.forEach(
            node => this.qt.remove(node)
        )

        created.forEach(
            node => this.qt.add(node)
        )
    }

    resizeHandler = (fromComponent = false) => {
        if ((fromComponent && undefined === this.containerWidth && undefined === this.containerHeight) || (!fromComponent)) {
            var container = document.getElementById('nodebookContainer')
            if (!container)
                return
            var x = container.clientWidth
            var y = container.clientHeight
            this.containerWidth = x
            this.containerHeight = y
            this._refs.svg.attr('width', (x < 0 ? 0 : x) + 'px')
            this._refs.svg.attr('height', (y < 0 ? 0 : y) + 'px')
        }
    }

    moveNodes = (dx, dy, nodes) => {
        for (var i = 0; i < nodes.length; i++) {
            // move each node in selection
            var node = this.props.nodesData[this.props.nodesHashTable[nodes[i]]]
            if (!node) {
                continue
            }

            node.x += dx/*this.currentZoomTransform.k*/
            node.y += dy/*this.currentZoomTransform.k*/
            if (node._jsx) {
                node._jsx.styleMove()
            }

            // move each node's links
            for (var li = 0; li < node.linksList.length; li++) {
                var link = this.props.linksData[this.props.linksHashTable[node.linksList[li]]]
                if (link.from_id === node.id) {
                    link.x1 = /*this.scaleX*/node.x
                    link.y1 = /*this.scaleY*/node.y
                    if (link._jsx) {
                        link._jsx.styleFromNodeMove()
                    }
                }
                if (link.to_id === node.id) {
                    link.x2 = /*this.scaleX*/node.x
                    link.y2 = /*this.scaleXY*/node.y
                    if (link._jsx) {
                        link._jsx.styleToNodeMove()
                    }
                }
            }

        }
    }

    nodeSelectWrapper = (nodeItem, isDrag = false, skipTrigger = false) => {
        this.props.selectNode(nodeItem, isDrag, skipTrigger)
    }

    nodeDragStartHandler = () => {
    }

    nodeDragHandler = (dx, dy) => {
        // this.props.socket.emit('moving node', {dx: dx, dy:dy, nodes:this.props.getSelection().nodes}, {id:this.props.nodebookid, authToken: this.props.authToken})
        this.moveNodes(dx, dy, this.props.getSelection().nodes)
    }

    nodeDragEndHandler = () => {
        let props = this.props.getSelection().nodes.map((value) => {
            let node = this.props.nodesData[this.props.nodesHashTable[value]];
            return ({ x: node.x, y: node.y })
        })
        this.props.selectionUpdateAll(props, { nodes: this.props.getSelection().nodes, links: [] }, null, false)

        this.props.getSelection().nodes.forEach(
            nodeId => {
                var node = this.props.nodesData[this.props.nodesHashTable[nodeId]]
                this.qt.remove(node)
            }
        )

        this.props.getSelection().nodes.forEach(
            nodeId => {
                var node = this.props.nodesData[this.props.nodesHashTable[nodeId]]
                this.qt.add(node)
            }
        )
    }

    nodeResizeHandler = (w, h, nodeId) => {
        // this.props.socket.emit('resizing node', {width: w, height: h, nodeId: nodeId}, {id:this.props.nodebookid, authToken: this.props.authToken})
    }

    nodeResizeEndHandler = (nodeItem) => {

        let nodeIds = this.props.getSelection().nodes
        let props = nodeIds.map((value) => {
            let node = this.props.nodesData[this.props.nodesHashTable[value]];
            return ({ x: node.x, y: node.y, width: node.width, height: node.height })
        })
        this.props.selectionUpdateAll(props, { nodes: nodeIds, links: [] }, null, false)

        nodeIds.forEach(
            nodeId => {
                var node = this.props.nodesData[this.props.nodesHashTable[nodeId]]
                this.qt.remove(node)
            }
        )

        nodeIds.forEach(
            nodeId => {
                var node = this.props.nodesData[this.props.nodesHashTable[nodeId]]
                this.qt.add(node)
            }
        )
    }

    // nodeResizeEndHandler = (nodeItem) => {
    //     this.props.selectionUpdateAll({width:nodeItem.width, height:nodeItem.height}, { nodes: [nodeItem.id], links: []}, null, false)
    // }

    // ODO , created=null, updated=null, deleted=null
    selectionChangeHandler = (change = null) => {

        var _s = this.props.getSelection()

        if (change) {
            // re-style deselected
            for (let i = 0; i < change.deselected.nodes.length; i++) {
                if (this.props.nodesData[this.props.nodesHashTable[change.deselected.nodes[i]]]._jsx) {
                    this.props.nodesData[this.props.nodesHashTable[change.deselected.nodes[i]]]._jsx.styleDeselect()
                }
            }
            for (let i = 0; i < change.deselected.links.length; i++) {
                if (this.props.linksData[this.props.linksHashTable[change.deselected.links[i]]]._jsx) {
                    this.props.linksData[this.props.linksHashTable[change.deselected.links[i]]]._jsx.styleDeselect()
                    this.props.linksData[this.props.linksHashTable[change.deselected.links[i]]]._jsx.styleDeselectHandles()
                }
            }
            // re-style selected
            for (let i = 0; i < change.selected.nodes.length; i++) {
                if (this.props.nodesData[this.props.nodesHashTable[change.selected.nodes[i]]]._jsx) {
                    this.props.nodesData[this.props.nodesHashTable[change.selected.nodes[i]]]._jsx.styleSelect()
                }
            }
            for (let i = 0; i < change.selected.links.length; i++) {
                if (this.props.linksData[this.props.linksHashTable[change.selected.links[i]]]._jsx) {
                    this.props.linksData[this.props.linksHashTable[change.selected.links[i]]]._jsx.styleSelect()
                }
            }
        }

        if (_s.links.length === 1 && _s.nodes.length === 0) {
            if (this.props.linksData[this.props.linksHashTable[_s.links[0]]]._jsx) {
                this.props.linksData[this.props.linksHashTable[_s.links[0]]]._jsx.styleSelectHandles()
            }
        } else {
            for (let i = 0; i < _s.links.length; i++) {
                if (this.props.linksData[this.props.linksHashTable[_s.links[i]]]._jsx) {
                    this.props.linksData[this.props.linksHashTable[_s.links[i]]]._jsx.styleDeselectHandles()
                }
            }
        }
    }

    keyUpHandler = (e) => {
        switch (e.keyCode) {
            case 37: this.leftKey = false; break;//this.panSvg(-1, 0); break; //Left
            case 38: this.upKey = false; break;//his.panSvg(0, -1); break; //Up
            case 39: this.rightKey = false; break; //this.panSvg(1, 0); break; //Right
            case 40: this.downKey = false; break; //this.panSvg(0, 1); break; //Down
            case 17: this.ctrlKey = false; break;
            default: break;
        }
    }
    keyDownHandler = (e) => {
        switch (e.keyCode) {
            case 37: this.leftKey = true; break;//this.panSvg(1, 0); break; //Left
            case 38: this.upKey = true; break;//this.panSvg(0, 1); break; //Up
            case 39: this.rightKey = true; break;//this.panSvg(-1, 0); break; //Right
            case 40: this.downKey = true; break; //this.panSvg(0, -1); break; //Down
            case 17: this.ctrlKey = true; break;
            default: break;
        }
    }

    transformTo = (x, y, k) => {
        var transform = d3.zoomIdentity.translate(x, y).scale(k);
        var transition = (canvas) => {
            canvas.transition()
                .duration(500)
                .call(this.zoom.transform, transform)
        }
        //this._refs.nodesAndLinkHolder.attr('transform', transform)
        this._refs.svg.call(transition)

        let transformations_cookie = localStorage.getItem(`ndbk${this.props.nodebookid}_transformations`)
        try { transformations_cookie = JSON.parse(transformations_cookie) } catch (err) { transformations_cookie = {} }
        transformations_cookie = { x: x, y: y, k: k }
        localStorage.setItem(`ndbk${this.props.nodebookid}_transformations`, JSON.stringify(transformations_cookie))
    }

    highlightConnections = (node) => {
        node.linksList.forEach(linkId => {
            let link = this.props.linksData[this.props.linksHashTable[linkId]]
            if (link._selectionId === -1 && link._jsx && link.properties.color !== 'hidden') {
                link._jsx.styleSelect()
            }
            let otherNodeId = link.from_id === node.id ? link.to_id : link.from_id
            var otherNode = this.props.nodesData[this.props.nodesHashTable[otherNodeId]]
            // if (otherNode._jsx && otherNode._selectionId===-1) {
            //     otherNode._jsx.styleSelect()
            // }
            if (otherNode._jsx && otherNode._jsx.styleLinked) {
                otherNode._jsx.styleLinked()
            }
        })
    }
    dehighlightConnections = (node) => {
        node.linksList.forEach(linkId => {
            let link = this.props.linksData[this.props.linksHashTable[linkId]]
            if (link._selectionId === -1 && link._jsx) {
                link._jsx.styleDeselect()
            }
            let otherNodeId = link.from_id === node.id ? link.to_id : link.from_id
            var otherNode = this.props.nodesData[this.props.nodesHashTable[otherNodeId]]
            // if (otherNode._jsx && otherNode._selectionId===-1) {
            //     otherNode._jsx.styleDeselect()
            // }
            if (otherNode._jsx && otherNode._jsx.destyleLinked) {
                otherNode._jsx.destyleLinked()
            }
        })
    }

    render() {
        //console.log("<Nodebook> render")

        const backgroundStyle = this.props.isNoBackground
            ? {
                background: "none"
            } : {
                outline: "none",
                backgroundImage: `url('${require('../images/noisebg_50.png')}')`,
                backgroundSize: "50%",
                backgroundRepeat: "repeat",
                backgroundColor: "white"
            }

        return (
            <svg
                className="nodebook-svg"
                ref={(c) => this._refs.svg = d3.select(c)}
                id="S_"
                tabIndex="-1"
                // onKeyDown={this.keyDownHandler}
                // onKeyUp={this.keyUpHandler}
                style={backgroundStyle}
            >
                <defs>
                    <linearGradient id="borderGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0.0" stopColor="#cd7d7e" />
                        <stop offset="0.6" stopColor="#df3ece" />
                        <stop offset="1.0" stopColor="#6c40eb" />
                    </linearGradient>
                    <linearGradient id="triangleGrad" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0.0" stopColor="transparent" />
                        <stop offset="0.5" stopColor="transparent" />
                        <stop offset="0.5" stopColor="#888" />
                        <stop offset="1.0" stopColor="#888" />
                    </linearGradient>
                    <filter id="doubleFilter" /*filterUnits="userSpaceOnUse" x="-50px" y="-50px" width="2000px" height="2000px"*/>
                        <feMorphology in="SourceGraphic" result="a" operator="dilate" radius="3" />
                        <feComposite in="SourceGraphic" in2="a" operator="xor" />
                    </filter>
                    <filter id="hoverEffectFilter">
                        <feColorMatrix type="matrix"
                            values="0.8 0 0 0 0
                                        0 0.91 0 0 0
                                        0 0 1 0 0
                                        0 0 0 1 0"/>
                    </filter>
                    <filter id="selectedEffectFilter">
                        <feColorMatrix type="matrix"
                            values="0.9 0 0 0 0
                                        0 0.95 0 0 0
                                        0 0 1 0 0
                                        0 0 0 1 0"/>
                    </filter>
                    <filter id="blueEffectFilter">
                        <feColorMatrix type="matrix"
                            values="0.26 0 0 0 0
                                        0 0.52 0 0 0
                                        0 0 0.95 0 0
                                        0 0 0 1 0"/>
                    </filter>
                    <filter id="edgeEffectFilter">
                        <feColorMatrix type="matrix"
                            values="0.6 0 0 0 0
                                        0 0.81 0 0 0
                                        0 0 1 0 0
                                        0 0 0 1 0"/>
                    </filter>
                    {/*<marker
                            id="diamond"
                            markerWidth="30"
                            markerHeight="36"
                            // refX="11"
                            // refY="21"
                            orient="auto"
                        >
                            <rect
                                // x="15"
                                // y="0"
                                height="14"
                                width="14"
                                className="node-link-marker"
                                // transform="rotate(-45)"
                            />
                            <text
                                x="2"
                                alignmentBaseline="hanging"
                                fill="white"
                                >S</text>
                        </marker>*/}
                    {/*<marker id="kruzicic" markerWidth="10" markerHeight="10">
                            <circle cx="0" cy="0" r="5" fill="red"/>
                        </marker>*/}
                    {/*<pattern ref={c=>this._shit=d3.select(c)} id="bgPattern" x="0" y="0" width="5" height="5" patternUnits="userSpaceOnUse">
                            <rect x="0" y="0" width="5" height="5" fill="#fff" strokeWidth="1" stroke="#e0e0e0" opacity="0.3" />
                        </pattern>*/}
                    <clipPath id="kruzic">
                        <circle cx="0" cy="0" r="25" />
                    </clipPath>
                </defs>
                {/*<g ref={c=>this._refs.background=d3.select(c)} style={{pointerEvents: 'none'}}>
                        <rect fill="url(#bgPattern)" x="0" y="0" width="100%" height="100%"/>
                    </g>*/}

                <g ref={c => this._refs.nodesAndLinkHolder = d3.select(c)}>
                    <g ref={c => this._refs.linkHolder = d3.select(c)}>
                        {
                            this.props.linksData.map(
                                (linkItem) => <BezierLink
                                    // edit={this.props.canEdit}
                                    edit={true}
                                    key={linkItem.id}
                                    // w1x={linkItem.w1x}
                                    // w1y={linkItem.w1y}
                                    // w2x={linkItem.w2x}
                                    // w2y={linkItem.w2y}
                                    properties={linkItem.properties}
                                    // {...linkItem.properties}
                                    _compareType={linkItem._compareType}
                                    keyPressDict={this.props.keyPressDict}
                                    linkItem={linkItem}
                                    clickHandler={this.props.selectLink}
                                    enqueueAttrChange={this.enqueueAttrChange}
                                    enqueueClassChange={this.enqueueClassChange}
                                    enqueueStyleChange={this.enqueueStyleChange}
                                    updateLinksRemotely={this.props.updateLinksRemotely}
                                    updateLinkShape={this.props.updateLinkShape}
                                />
                            )
                        }
                    </g>

                    <g ref={c => this._refs.nodeHolder = d3.select(c)}>
                        {
                            this.props.nodesData.map(
                                (nodeItem) => {
                                    // if (!nodeItem._cullPassed) return null
                                    var Component = this.props.templatesData[nodeItem.properties.templateId].component
                                    return (
                                        <Component
                                            // edit={this.props.canEdit}
                                            edit={true}
                                            nodebookComponent={this}
                                            key={nodeItem.id}
                                            nodeItem={nodeItem}
                                            hideCtxMenus={this.props.hideCtxMenus}
                                            dragStartHandler={this.nodeDragStartHandler}
                                            dragHandler={this.nodeDragHandler}
                                            dragEndHandler={this.nodeDragEndHandler}
                                            resizeHandler={this.nodeResizeHandler}
                                            resizeEndHandler={this.nodeResizeEndHandler}
                                            clickHandler={this.nodeSelectWrapper}
                                            keyPressDict={this.props.keyPressDict}
                                            createLink={this.props.createLink}
                                            canCreateLink={this.props.canCreateLink}
                                            selectionDeleteAll={this.props.selectionDeleteAll}
                                            enqueueAttrChange={this.enqueueAttrChange}
                                            enqueueClassChange={this.enqueueClassChange}
                                            enqueueStyleChange={this.enqueueStyleChange}
                                            {
                                            ...nodeItem.properties
                                            }
                                            _compareType={nodeItem._compareType}
                                            {
                                            ...nodeItem.settings
                                            }
                                            highlightConnections={this.highlightConnections}
                                            dehighlightConnections={this.dehighlightConnections}
                                        // commentsCnt={nodeItem.comments}
                                        // transformX={this.state.zt.x}
                                        // transformY={this.state.zt.y}
                                        // transformK={this.state.zt.k}
                                        />
                                    )
                                }
                            )
                        }
                    </g>
                </g>

                <g
                    ref={c => this._refs.brushHolder = d3.select(c)}
                    className="nodebook-brush"
                >
                </g>

                <Uber
                    executeSearch={this.props.executeSearch}
                    ref={c => this._refs.uber = c}
                    templatesFieldList={this.props.templatesFieldList}
                    uberActive={this.props.uberActive}
                />
            </svg>
        );
    }
}

export default Nodebook;


// KLASTERIIIIIIIIIIIII

// if (oldZoomTransform.k < this.currentZoomTransform.k) {
//     // zoom in

//     // neki markeri postaju nodovi

//     this.props.nodesData.forEach(
//         node => node.refs.background.style('fill', 'rgba(0,0,0,0.1')
//     )
// }
// if (oldZoomTransform.k > this.currentZoomTransform.k) {
//     // zoom out
//     console.log('zoom out')
//     // var hash = Date.now()

//     // neki nodovi postaju marker

//     var MAX_NODE_WIDTH = 300
//     var MAX_NODE_HEIGHT = 200

//     var overlapping_groups = []

//     var nodesCount = this.props.nodesData.length

//     for (var i=0; i<nodesCount; i++) {
//         // nadji okolne
//         // TODO don't do double check for same pair of nodes
//         var node = this.props.nodesData[i]

//         // if (node.id != 3303/*2657*//*2937*/)
//         //     continue

//         var nodeSeacrhArea = {
//             x: node.x - MAX_NODE_WIDTH,
//             y: node.y - MAX_NODE_HEIGHT,
//             width: node.width + MAX_NODE_WIDTH,
//             height: node.height + MAX_NODE_HEIGHT,
//         }
//         // TODO filtriraj smao one koji su unutar viewport-a
//         this.quadtrees.nodes.visit(
//             (tile, tile_x1, tile_y1, tile_x2, tile_y2) => {
//                 var should_stop_propagation = false

//                 if (!tile.length) {
//                     do {
//                         // this is the leaf tile
//                         var otherNode = tile.data
//                         if (otherNode.id != node.id) {
//                             var nodesHaveOverlap = this.testOverlap(otherNode, node)
//                             otherNode.refs.background.style('fill', 'rgba(255, 127, 0, 0.1)')
//                             if (nodesHaveOverlap) {
//                                 otherNode.refs.background.style('fill', 'rgba(0, 255, 0, 0.1)')
//                             }
//                         }

//                     } while (tile = tile.next)
//                 } else {
//                     // this is just one more tile
//                     // TODO check scalling for width and height
//                     // TODO TODO TODO
//                     // should_stop_propagation = !this.testOverlap({
//                     //     x: tile_x1,
//                     //     y: tile_y1,
//                     //     width: tile_x2-tile_x1,
//                     //     height: tile_y2-tile_y1,
//                     // }, nodeSeacrhArea, false)
//                 }

//                 return should_stop_propagation
//             }
//         )
//     }
// }



// // TODO it only translation on the transformation, maybe we can just move the group

// for (var i=0; i<this.props.nodesData.length; i++) {
//     var node = this.props.nodesData[i]
//     var x = this.scaleX(node.x)
//     var y = this.scaleY(node.y)
//     this.enqueueAttrChange({
//         elem: node.refs.holder,
//         attr: 'transform',
//         val: `translate(${x} ${y})`
//     });
// }

// this.props.linksData.forEach(
//     link => {
//         // scale line
//         this.enqueueAttrChange({
//             elem: link.refs.line,
//             attr: 'x1',
//             val: this.scaleX(link.x1),
//         });
//         this.enqueueAttrChange({
//             elem: link.refs.line,
//             attr: 'y1',
//             val: this.scaleY(link.y1),
//         });
//         this.enqueueAttrChange({
//             elem: link.refs.line,
//             attr: 'x2',
//             val: this.scaleX(link.x2),
//         });
//         this.enqueueAttrChange({
//             elem: link.refs.line,
//             attr: 'y2',
//             val: this.scaleY(link.y2),
//         });
//         // scale mousecatcher
//         this.enqueueAttrChange({
//             elem: link.refs.mouseCatcher,
//             attr: 'x1',
//             val: this.scaleX(link.x1),
//         });
//         this.enqueueAttrChange({
//             elem: link.refs.mouseCatcher,
//             attr: 'y1',
//             val: this.scaleY(link.y1),
//         });
//         this.enqueueAttrChange({
//             elem: link.refs.mouseCatcher,
//             attr: 'x2',
//             val: this.scaleX(link.x2),
//         });
//         this.enqueueAttrChange({
//             elem: link.refs.mouseCatcher,
//             attr: 'y2',
//             val: this.scaleY(link.y2),
//         });
//     }
// )

// scaleX = (x) => {
//     return x*this.currentZoomTransform.k + this.currentZoomTransform.x
// }

// scaleY = (y) => {
//     return y*this.currentZoomTransform.k + this.currentZoomTransform.y
// }

// scaleXY = (_item) => {
//     _item.x = _item.x*this.currentZoomTransform.k + this.currentZoomTransform.x
//     _item.y = _item.y*this.currentZoomTransform.k + this.currentZoomTransform.y
//     return _item
// }

// testOverlap(a, b, doScale=true) {
//     var _a = {}, _b = {}

//     // TODO check scalling for width and height

//     if (doScale) {
//         _a.x = a.x * this.currentZoomTransform.k
//         _a.y = a.y * this.currentZoomTransform.k
//         _a.width = a.width
//         _a.height = a.height

//         _b.x = b.x * this.currentZoomTransform.k
//         _b.y = b.y * this.currentZoomTransform.k
//         _b.width = b.width
//         _b.height = b.height
//     } else {
//         _a.x = a.x
//         _a.y = a.y
//         _a.width = a.width/this.currentZoomTransform.k
//         _a.height = a.height/this.currentZoomTransform.k

//         _b.x = b.x
//         _b.y = b.y
//         _b.width = b.width/this.currentZoomTransform.k
//         _b.height = b.height/this.currentZoomTransform.k
//     }

//     return (
//         (_a.x < _b.x+_b.width) &&
//         (_a.x+_a.width > _b.x) &&
//         (_a.y < _b.y+_b.height) &&
//         (_a.y+_a.height > _b.y)
//     )
// }

// PARALLAX

/*
<pattern ref={c=>this._shit=d3.select(c)} id="bgPattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
    <rect x="0" y="0" width="101" height="101" fill="#f8f8f8" strokeWidth="1" stroke="#888" opacity="0.3" />
</pattern>
<filter id="f3" x="0" y="0" width="200%" height="200%">
    <feOffset result="offOut" in="SourceAlpha" dx="5" dy="5" />
    <feGaussianBlur result="blurOut" in="offOut" stdDeviation="7" />
    <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
</filter>*/



// WEBPACK FOOTER //
// ./src/components/Nodebook.js